module.exports = __webpack_public_path__ + "static/media/ctr.2279606a.svg";